import { openWindow } from '@/common';
import { newBroadcastChannel } from '../../../messaging';

export class LoginSuccessful {
  static eventName = 'login.successful';

  eventName: string;

  platform: string;

  sessionId: number;

  constructor(platform: string, sessionId: number) {
    this.eventName = LoginSuccessful.eventName;
    this.platform = platform;
    this.sessionId = sessionId;
  }
}

export class LoginError {
  static eventName = 'login.error';

  eventName: string;

  platform: string;

  constructor(platform: string) {
    this.eventName = LoginError.eventName;
    this.platform = platform;
  }
}

export async function requestLogin(platform: string): Promise<number|null> {
  return new Promise((resolve, reject) => {
    let bc: BroadcastChannel|null = newBroadcastChannel();

    const onMessage = (event: MessageEvent) => {
      if (!bc) return;
      const cleanup = () => {
        if (!bc) return;
        bc.removeEventListener('message', onMessage);
        bc.close();
        bc = null;
      };
      if (typeof event.data.platform === 'undefined') return;
      if (event.data.platform !== platform) return;
      if (event.data.eventName === LoginSuccessful.eventName) {
        cleanup();
        resolve((event.data as LoginSuccessful).sessionId);
      }
      if (event.data.eventName === LoginError.eventName) {
        cleanup();
        reject(new Error('Login error'));
      }
    };

    bc.addEventListener('message', onMessage);
    const windowOpts = {
      dimensions: { maxWidth: 400, maxHeight: 400 },
      onClose() {
        if (bc) {
          bc.removeEventListener('message', onMessage);
          bc.close();
          bc = null;
          resolve(null);
        }
      },
    };
    openWindow(`/iam/external/auth/login/${platform}`, windowOpts);
  });
}
